import PageTitle from "../../../components/PageTitle/PageTitle";
import CardCount from "../../../components/CardCount/CardCount";
import { Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { httprequest } from "../../../data/api";
import { ToastContainer, toast } from "react-toastify";
import { Group as StudentIcon, School as GraduateIcon, Class as ClassIcon, EmojiPeople as TeacherIcon } from "@mui/icons-material";

// -- SCHOOL ENDPOINT
const SCHOOL_ENDPOINT = "/admin/v1/school";
const ALL_CLASSES_ENDPOINT = "/admin/v1/classes";

const SchoolOverview = () => {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [classData, setClassData] = useState([]);

  const getAllClasses = () => {
    httprequest.get(`${ALL_CLASSES_ENDPOINT}/${id}`).then((res) => {
      setClassData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  useEffect(() => {
    httprequest.get(`${SCHOOL_ENDPOINT}/${id}`).then((res) => {
      // eslint-disable-next-line no-console
      console.log(res?.data?.data?.school_name);
      setData(res?.data?.data || {});
    }).catch((err) => {
      toast.error(err?.res);
    });

    getAllClasses();
  }, []);

  return (
    <div>
      <div className="padding-right padding-bottom overview">
        <PageTitle
          // eslint-disable-next-line no-template-curly-in-string
          title={`${data?.school_name || "School Overview"}`}
          subtitle="See the overview of everything going on at your School."
        />
        <Grid container spacing={2}>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <CardCount
              title="Total Students"
              count={`${data?.academics?.students ?? data?.count ?? 0}`}
              icon={<StudentIcon />}
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <CardCount
              title="Total Teachers"
              count={`${data?.staff_and_admin?.employees ?? data?.no_of_employees ?? 0}`}
              icon={<TeacherIcon />}
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <CardCount
              title="Number of classes"
              count={`${classData.length}`}
              icon={<ClassIcon />}
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <CardCount
              title="Graduating classes"
              count={4}
              icon={<GraduateIcon />}
            />
          </Grid>
        </Grid>
      </div>
      <ToastContainer />
    </div>
  );
};

export default SchoolOverview;
